import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import { withStyles, Dialog, DialogContent, DialogTitle, Tabs, Tab, IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import ActionCreators from './../../store/actions/index';
import UserProfile from './UserProfile';
import ChangePassword from "./ChangePassword";

const useStyles = theme => ({
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    formContainer: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 320,
        width: '100%',
        margin: theme.spacing(1)
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1)
    },
});

const TabPanel = ({value, index, children}) => value === index && <>{children}</>;

const UserDialog = props => {
    const { classes, open, username } = props;
    const [tab, setTab] = useState(0);

    const handleClose = () => {
        props.changeUserDialog(false);
    }

    const handlePasswordChange = (data) => {
        if(data.newPassword === data.confirmPassword)
            props.changePassword(data);
    };

    const handleUsernameSubmit = (data) => {
        props.changeUsername(data);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                Konto użytkownika
                <IconButton
                    className={classes.closeButton}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.content}>
                <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)}>
                    <Tab label="Profil" value={0} />
                    <Tab label="Hasło" value={1} />
                </Tabs>
                    <TabPanel value={tab} index={0}>
                        <UserProfile
                            containerClass={classes.formContainer}
                            name={username}
                            onSubmit={handleUsernameSubmit}
                        />
                    </TabPanel>
                    <TabPanel value={tab} index={1}>
                        <ChangePassword
                            containerClass={classes.formContainer}
                            onSubmit={handlePasswordChange}
                        />
                    </TabPanel>
            </DialogContent>
        </Dialog>
    )
}

UserDialog.propTypes = {
    classes: PropTypes.object,
    //redux
    open: PropTypes.bool,
    username: PropTypes.string
};

const mapStateToProps = (state) => ({
    open: state.userReducer.dialogOpen,
    username: state.authReducer.operator,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreators, dispatch);
}


export default compose(
    withStyles(useStyles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(UserDialog)
